export default function getTimeFromDate(targetDate) {
  let _date;
  let timeArr = [];
  _date = new Date(targetDate).toLocaleTimeString();
  timeArr = _date.split(":");
  return `${timeArr[0]}:${timeArr[1]}`;
}
